import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import icMoreVert from '@iconify/icons-ic/twotone-more-vert';
import icClose from '@iconify/icons-ic/twotone-close';
import icPrint from '@iconify/icons-ic/twotone-print';
import icDownload from '@iconify/icons-ic/twotone-cloud-download';
import icDelete from '@iconify/icons-ic/twotone-delete';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icPerson from '@iconify/icons-ic/twotone-person';
import icMyLocation from '@iconify/icons-ic/twotone-my-location';
import icLocationCity from '@iconify/icons-ic/twotone-location-city';
import icEditLocation from '@iconify/icons-ic/twotone-edit-location';
import icNotes from '@iconify/icons-ic/twotone-notes';
import { LogsService } from '../../services/logs.service';

@Component({
  selector: 'vex-log-display',
  templateUrl: './log-display.component.html',
  styleUrls: ['./log-display.component.scss']
})
export class LogDisplayComponent implements OnInit {

  icClose = icClose; 
  icPhone = icPhone;
  icNotes = icNotes;

  logData: string;

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
              private dialogRef: MatDialogRef<LogDisplayComponent>,
              private logsService: LogsService) { }

  ngOnInit(): void {
    console.log("LOG DATA", this.defaults); 

    const actionSpecs = this.defaults['actionSpecs'];

    if ( actionSpecs == 'ifaces')
    {
      this.logsService.loadIfaceLogs(this.defaults).subscribe((data:any) => {
        console.log("data", data);
        this.logData = data.response.result[0].longData;
      });
    } 

    if (!actionSpecs)
      this.logData = this.defaults.response.result[0].longData;
   
  }

}
